import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["search"];
import { useLocation } from 'react-router-dom';
import { VIDEO_TIMESTAMP_PARAM } from '../video';
const STRIPPED_PARAMS_ON_NAVIGATE = [VIDEO_TIMESTAMP_PARAM];
export const useSanitizedLocation = () => {
  const _useLocation = useLocation(),
    {
      search
    } = _useLocation,
    props = _objectWithoutPropertiesLoose(_useLocation, _excluded);
  const queryParams = new URLSearchParams(search);
  STRIPPED_PARAMS_ON_NAVIGATE.forEach(p => {
    if (queryParams.has(p)) queryParams.delete(p);
  });
  return Object.assign({}, props, {
    search: queryParams.toString()
  });
};